var prop = function (obj, key, _default) {
    return obj && obj.hasOwnProperty(key) ? obj[key] : _default;
};
export default prop;
